module.exports = __webpack_public_path__ + "static/img/cjsdjhhcx00210cc.c976fba9.jpg";